import * as css from './AccountRealtime.css';
import {useSelector} from 'react-redux';
import useShow from '../../../hooks/useShow';
import UserProfileMenu from '../../../layout/topMenu/layoutUserProfile/layoutUserProfileMenu/LayoutUserProfileMenu';
import {ThemeProvider} from 'styled-components';
import {ProfileCard} from '../components/profile/ProfileCard';
import BtnAdd from '../../../component/button/btnAdd/BtnAdd';
import {useTranslation} from 'react-i18next';
import useGlobalShow from '../../../hooks/useGlobalShow';
import {useEffect} from 'react';
import {getRealtimeText} from '../../../redux/realtime/realtimeActions';
import {EXCLUDE_ACCOUNT_MANAGER_MANAGEMENT} from '../../../config/config';
import store from '../../../store';
import RealtimeHeader from '../realtimeHeader/RealtimeHeader';
import AccountHeader from '../components/accountHeader/AccountHeader/AccountHeader';
import WindowReports from '../components/windowReports/WindowReports';
// import AccountCash from '../components/accountCash/AccountCash';
import {hasAccountRoleAccess} from '../../../functions/permission';
export  const showDetailsAccountPixel=()=>{
    const {pid,userAccountRole}=store.getState().account;
    return (userAccountRole!=='manager' || !EXCLUDE_ACCOUNT_MANAGER_MANAGEMENT.includes(pid));

};
function AccountRealtime () {
    const event = useSelector((s: any) => s.event);
    const user = useSelector((s: any) => s.user);
    const realtimeDesign = useSelector((s: any) => s.realtime.user.realtimeDesign);
    const showProfile = useShow();
    const showManageEvent = useGlobalShow('isOpenCreateEvent');
    const {t} = useTranslation('package');
    const {realtimeText,getRealtimeTextXHR} = useSelector((s:any) => s.realtime.event);

    useEffect(() => {
        if(!realtimeText?.he && !getRealtimeTextXHR)
            getRealtimeText().then();
    }, []);

    return (
        <ThemeProvider theme={{isDarkMode: realtimeDesign?.darkDisplay}}>
            <css.wrapper data-cy="accountRealtime" colors={event.colors}>
                <RealtimeHeader/>
                {!!showProfile.isOpen &&
                    <UserProfileMenu close={showProfile.close} closeMenu={showProfile.close} hide={false}
                        showEvents={() => {
                        }} userImgPath={user.picture} userName={`${user.nameFirst} ${user.nameLast}`}/>}
                <css.gridTop>
                    <ProfileCard openProfile={showProfile.open}/>
                    <AccountHeader/>
                </css.gridTop>
                {hasAccountRoleAccess('manage package') &&
                <css.gridContainer rolePermission={hasAccountRoleAccess('manage package')}>
                    <css.eventSection>
                        <css.image/>
                        <css.text>{t('firstPageText')}</css.text>
                        <BtnAdd text={t('firstPageBtn')} state={showManageEvent.isOpen} onClick={showManageEvent.open}/>
                    </css.eventSection>
                    <WindowReports/>
                    {/* <AccountCash/> */}
                </css.gridContainer>}
            </css.wrapper>

        </ThemeProvider>
    );
}

export default AccountRealtime;
